export default "__VITE_ASSET__BU315ec8__"